import { useQuery } from "react-query";
import { getSchedulingSettings } from "../../components/api/Scheduling/settings";
import { onError } from "./onError";

export const schedulingSettingsKeys = {
  one: (organizationRef) => ["scheduling-settings", organizationRef],
};

export function useSchedulingSettingsQuery({ organizationRef, enabled = true, onSuccess }) {
  return useQuery(
    schedulingSettingsKeys.one(organizationRef),
    async () => {
      const res = await getSchedulingSettings({ organizationRef });
      return res?.settings || res;
    },
    {
      enabled: !!organizationRef && enabled,
      refetchOnWindowFocus: false,
      onSuccess,
      onError,
    }
  );
}
